export class RecebivelUpdated {
  id: string;
  transacao_recebivel_status_id: string;
  transacao_split_id: string;
  regra_divisao: string;
  valor: string;
  valor_bruto: string;
  valor_taxa_antecipacao: string;
  reembolsavel_rejeicao: string;
  parcela: string;
  data_pagamento: string;
  data_pagamento_calculada: string;
  data_previsao_recebimento: string;
  vendedor_nome: string;
  status: string;
  transacao_parcela: number;
  transacao_recebivel_created_at: string;

  constructor(
    id?: string,
    transacao_recebivel_status_id?: string,
    transacao_split_id?: string,
    regra_divisao?: string,
    valor?: string,
    valor_bruto?: string,
    valor_taxa_antecipacao?: string,
    reembolsavel_rejeicao?: string,
    parcela?: string,
    data_pagamento?: string,
    data_pagamento_calculada?: string,
    data_previsao_recebimento?: string,
    vendedor_nome?: string,
    status?: string,
    transacao_parcela?: number,
    transacao_recebivel_created_at?: string
    
  ) {
    this.id = id;
    this.transacao_recebivel_status_id = transacao_recebivel_status_id;
    this.transacao_split_id = transacao_split_id;
    this.regra_divisao = regra_divisao;
    this.valor = valor;
    this.valor_bruto = valor_bruto;
    this.valor_taxa_antecipacao = valor_taxa_antecipacao;
    this.reembolsavel_rejeicao = reembolsavel_rejeicao;
    this.parcela = parcela;
    this.data_pagamento = data_pagamento;
    this.data_pagamento_calculada = data_pagamento_calculada;
    this.data_previsao_recebimento = data_previsao_recebimento;
    this.vendedor_nome = vendedor_nome;
    this.status = status;
    this.transacao_parcela = transacao_parcela;
    this.transacao_recebivel_created_at = transacao_recebivel_created_at;
  }
}
